"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _this = void 0;

var post = function post(url, data, callback) {
  var request = new XMLHttpRequest();

  request.onload = function () {
    if (_this.status >= 200 && _this.status < 400) {
      // Success!
      callback(JSON.parse(_this.response));
    } else {
      // We reached our target server, but it returned an error
      callback({});
    }
  };

  request.onerror = function () {
    // There was a connection error of some sort
    callback({});
  };

  request.open('POST', url, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send(data);
};

var getDictionaryTexts = function getDictionaryTexts(settings, callback, theLang) {
  var dictionary = [];
  $.each(settings, function (group, texts) {
    $.each(texts, function (key, text) {
      dictionary.push({
        key: "".concat(group, "/").concat(key),
        text: text
      });
    });
  });
  var url = theLang ? '/webservices/dictionary.svc/gettextslanguage/'.concat(theLang) : '/webservices/dictionary.svc/gettexts';
  post(url, JSON.stringify(dictionary), function (data) {
    $.each(data, function (index, value) {
      var keyPart = value.key.split('/');
      settings[keyPart[0]][keyPart[1]] = value.text;
    });
    callback.apply();
  });
};

var _default = getDictionaryTexts;
exports["default"] = _default;